import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveActivityLog(context, data) {
      try {
        const activityLog = await axios.get(`/activity-log/${data.type}/${data.subtype}`, { withCredentials: true });
        return activityLog.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
